import { render, staticRenderFns } from "./shop-product-regular-delivery.vue?vue&type=template&id=392e9764&"
import script from "./shop-product-regular-delivery.vue?vue&type=script&lang=js&"
export * from "./shop-product-regular-delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports